import React from "react";
import * as dc from "dc";
import { ChartTemplate } from "./chartTemplate";
import * as d3 from "d3";

const dataCountChartFunc = (divRef, ndx) => {
  const all = ndx.groupAll();

  const countChart = dc.dataCount(divRef);
  countChart
    .crossfilter(ndx)
    .groupAll(all)
    // .formatNumber(d3.format(".g"))
    .html({
      some: '<span style="color:black; font-weight: bold;">%filter-count</span> out of %total-count',
      // some: "<strong>%filter-count</strong> out of %total-count Number of Investment Opportunities Selected",
      // all: " %total-count Number of Investment Opportunities. Click on charts to apply filters",
      all: '<span style="color:black; font-weight: bold;"> %total-count</span>',
    });

  return countChart;
};

export const DataCountChart = (props) => (
  <ChartTemplate
    chartFunction={dataCountChartFunc}
    // title="Gender of Financing Recipient"
    name="Total Records"
  />
);
